import type {ReservationSource} from "../models/reservation";

export const maxPhotoSize = {width: 1080, height: 1080};

export const channelsSupportSendingPhotos: ReservationSource[] = [
    "Airbnb",
    "Booking",
    "HomeAway",
    "Houfy",
    "internal"
];
